import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ref from '../entities/ref'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import AppConsts from '@/lib/appconst';

interface RefState extends ListState<Ref> {
    refTypesForSelect : Ref[],
}
class RefModule extends ListModule<RefState, any, Ref>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Ref>(),
        loading: false,
        refTypesForSelect : new Array<Ref>(),
    }
    actions = {
        async getCommonRefsForSelect(context: ActionContext<RefState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Ref/GetRefsForSelect', { params : payload.data });
            return reponse.data.result.items as Ref[];
        },
        async getRefsForSelect(context: ActionContext<RefState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Ref/GetRefsForSelect', { params : payload.param });
            return reponse.data.result.items as Ref[];
            
        },
        async getRefTypesForSelect(context: ActionContext<RefState, any>) {
            let reponse = await Ajax.get('/api/services/app/Ref/GetRefTypesForSelect');
            context.state.refTypesForSelect = reponse.data.result.items as Ref[];
        }
    };
    mutations = {
        setCurrentPage(state: RefState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: RefState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const refModule = new RefModule();
export default refModule;